<template>
  <v-radio-group :value="value" @change="onInput">
    <v-radio
      v-for="(option, optionIdx) in options"
      :value="option.value"
      :label="option.label"
      :key="optionIdx"
      class="form-radio"
      :class="[
        option.class ? option.class : '',
        value === option.value && option.selectedClass ? option.selectedClass : '',
      ]"
    >
      <template v-if="!option.label" v-slot:label>
        <slot name="label" :option="option" />
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script>
export default {
  name: 'FormRadioGroup',
  components: {},
  props: {
    value: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.form-radio {
  padding: 16px !important;
  gap: 8px;

  .theme--light {
    color: unset !important;
  }
}
</style>
